import { render, staticRenderFns } from "./TableHistoricalAccessControl.vue?vue&type=template&id=9c9fe3d0&"
import script from "./TableHistoricalAccessControl.vue?vue&type=script&lang=js&"
export * from "./TableHistoricalAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports